<div class="card">
    <div class="card-body">
        <div *ngIf="isForSystemTest" style="color: red; font-weight: bold; font-size: 16px; margin-bottom: 10px;">
            <a><b>Dieser Mandant ist für Systemtests angelegt!</b></a>
            <br><br>
        </div>
        <form [formGroup]="editTenantForm" novalidate>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field style="width: 0; height: 0;">
                        <input matInput hidden  formControlName="id">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Max. Anzahl Mitglieder" formControlName="maxUserCount">
                    </mat-form-field>
                </div>
            </div>

            <br><br>

            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
            (click)="cancel()" >Abbruch</button>
            <!-- <span style="flex: 1 1 auto"></span> -->
            <button mat-raised-button type="submit" class="btn btn-squirrel pull-right"
                (click)="editTenant()">{{this.translate.data['MODIFY'] | translate}}</button>
            <div class="clearfix"></div>
        </form>
    </div>
</div> 